const round = precision => number =>
  Math.round(number * precision) / precision;

export const round2 = round(1e2);
export const round3 = round(1e3);
export const round4 = round(1e4);
export const round5 = round(1e5);
export const round6 = round(1e6);
export const round7 = round(1e7);
export const round8 = round(1e8);

// rounds number to 6 decimals, fills decimals with zeroes if there's less than 6 after the dot
export const round6AndFormatValue = value => round6(value).toFixed(6);

const significantFigures = precision => number =>
  number.toPrecision(precision);

export const significantFigures7 = significantFigures(7);

export const significantFigures7AndFormatValue = value => {
  let newValue = Number(significantFigures7(value));
  if (newValue < 0.0001) {
    newValue = newValue.toExponential(6);
  }

  return newValue;
};
